import React from 'react';

const ListError = ({ message }: { message: React.ReactNode }) => {
    return (
        <div
            style={{
                height: window.innerHeight > 1052 ? '500px' : '260px',
                width: '100%',
            }}
        >
            {message}
        </div>
    );
};

export default ListError;
